module.exports = __webpack_public_path__ + "img/mdtCloud-logo-small.4c4891e8.png";